<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation">
        <v-toolbar text color="white">
            <v-form @submit="submitForm">
                <v-autocomplete
                    v-model="select"
                    :items="items"
                    :loading="loading"
                    :search-input.sync="search"
                    solo
                    single-line
                    text
                    clearable
                    color="black"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="cur_id"
                    placeholder="Поиск по названию"
                    prepend-icon="search"
                    append-icon=""
                    return-object/>
            </v-form>

            <v-spacer/>

            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="addCategory">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>

        <v-list v-if="getCatalog.length > 0">
            <v-list-group v-for="category in getCatalog" :key="category.id">
                <v-list-item slot="activator">
                    <v-list-item-title v-text="category.name" @click="editCategory(category.id)"/>
                    <v-list-item-action>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon @click.prevent="categoryChangeStatus(category.id, category.status)"
                                       v-on="on">
                                    <v-icon>{{ category.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Статус</span>
                        </v-tooltip>
                    </v-list-item-action>

                    <v-list-item-action>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon :to="{ name: 'addProduct', query: { categoryId: category.id } }"
                                       v-on="on">
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </template>
                            <span>Добавить продукт</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>

                <v-list-item
                    :key="product.id"
                    active-class="active"
                    v-for="product in category.products_all"
                    :class="$route.query.productId === product.id ? `active` : ``">
                    <v-list-item-title v-text="product.name" @click="editProduct(product.id)"/>
                    <v-list-item-action>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon @click.prevent="productChangeStatus(product.id, product.status)"
                                       v-on="on">
                                    <template v-if="product.status">
                                        <v-icon>remove_red_eye</v-icon>
                                    </template>

                                    <template v-else>
                                        <v-icon>visibility_off</v-icon>
                                    </template>
                                </v-btn>
                            </template>
                            <span>Статус</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
            </v-list-group>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Category from '../../../api/category'
    import Product from '../../../api/product'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'categoryNavigation',
        components: { Empty },
        data: () => ({
            select: null,
            items: [],
            loading: false,
            search: null,
        }),
        methods: {
            addCategory () {
                this.$router.push({ name: 'addCategory' })
            },
            categoryChangeStatus (id, status) {
                Category
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('changeCategoryStatus', response.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус категории и продуктов изменен успешно',
                            color: 'info'
                        })
                    })
                    .catch(error => new Error(error))
            },
            productChangeStatus (id, status) {
                Product
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('changeProductStatus', response.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус продукта изменен успешно',
                            color: 'info'
                        })
                    })
                    .catch(error => new Error(error))
            },
            editCategory (id) {
                this.$router.push({
                    name: 'editCategory',
                    params: { categoryId: id }
                })
            },
            editProduct (id) {
                this.$router.push({
                    name: 'editProduct',
                    query: { productId: id }
                })
            },
            searchByName (name) {
                this.loading = true

                Category
                    .searchByName({ name })
                    .then(response => this.items = response.data.data)
                    .catch(error => {
                        if (error && error.response.headers && error.response.status === 404) {
                            this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        }

                        this.select = null
                    })
                    .finally(() => this.loading = false)
            },
            submitForm (event) {
                event.preventDefault()

                this.searchByName(this.search)
            }
        },
        computed: mapGetters([
            'getCatalog'
        ]),
        watch: {
            select (value) {
                if (!value) return

                value.is_prod ? this.editProduct(value.cur_id) : this.editCategory(value.cur_id)
            },
            search (value) {
                if (!value || value.length <= 3 || value === this.select) {
                    return false
                }
            }
        }
    }
</script>
